import * as remoteAction from "../remoteAction";

export type PollForRewardActionSuccess = remoteAction.MerchantRemoteResponse<
  "POLL_FOR_REWARD_SUCCESS",
  any
>;
export type PollForRewardActionFailure = remoteAction.MerchantRemoteResponse<
  "POLL_FOR_REWARD_FAILURE",
  any
>;
export type PollForRewardActionRequest = remoteAction.MerchantRemoteResponse<
  "POLL_FOR_REWARD_REQUEST",
  any
>;

export interface PollForRewardAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "POLL_FOR_REWARD_REQUEST";
    success: "POLL_FOR_REWARD_SUCCESS";
    failure: "POLL_FOR_REWARD_FAILURE";
  };
}

export interface PollForRewardParams {
  transactionId: string;
}

export const pollForReward = ({
  transactionId,
}: PollForRewardParams): PollForRewardAction => ({
  type: "MERCHANT_REMOTE_REQUEST",
  types: {
    request: "POLL_FOR_REWARD_REQUEST",
    failure: "POLL_FOR_REWARD_FAILURE",
    success: "POLL_FOR_REWARD_SUCCESS",
  },
  method: "GET",
  https: true,
  params: { channel: transactionId, type: "transaction" },

  url: `/lpoll`,
});
